import { Navigate, Outlet } from 'react-router-dom';

const PublicRoute = ({ user, redirectTo = "/dashboard" }) => {
  // If user is logged in, redirect to dashboard
  if (user) {
    return <Navigate to={redirectTo} replace />;
  }

  // For nested routes
  return <Outlet />;
};

export default PublicRoute;
